import * as React from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers';

export default function MuiDateTimePicker({ wrapperClasses, label, value, onChange, fullWidth, disabled }) {
  // const [value, setValue] = React.useState(null);

  return (
    <span
      className={wrapperClasses + " shadow-sm"}
    >


      <LocalizationProvider dateAdapter={AdapterDayjs}
      >
        <DemoContainer components={['DateTimePicker']}>

          <DateTimePicker
            className={` ${fullWidth ? 'w-full' : ''}`}
            sx={{ minWidth: 150 }}
            readOnly={disabled}
            label={label}
            value={value ? dayjs(value) : null}
            onChange={onChange}
            format='DD-MM-YYYY HH:mm:ss'
            
            // format='DD-MM-YYYY'
          />
        </DemoContainer>
      </LocalizationProvider>
    </span>
  );
}